var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _g2, _path19, _g3, _rect9, _g4, _rect10, _g5, _g6, _g7, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g8, _path27, _g9, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g10, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g11, _g12, _path47, _path48, _path49, _path50, _g13, _path51, _path52, _path53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInactive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "INACTIVE",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 372.56,
    viewBox: "0 0 500 372.56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9502",
    "data-name": "Ret\\xE2ngulo 9502",
    width: 500,
    height: 372.56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9482",
    "data-name": "Ret\\xE2ngulo 9482",
    width: 101.247,
    height: 92.378,
    transform: "translate(292.007 108.432)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9483",
    "data-name": "Ret\\xE2ngulo 9483",
    width: 6.691,
    height: 97.748,
    transform: "translate(129.321 231.991)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9484",
    "data-name": "Ret\\xE2ngulo 9484",
    width: 6.691,
    height: 97.789,
    transform: "translate(338.609 231.95)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9487",
    "data-name": "Ret\\xE2ngulo 9487",
    width: 229.359,
    height: 32.667,
    transform: "translate(122.631 244.374)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9489",
    "data-name": "Ret\\xE2ngulo 9489",
    width: 202.597,
    height: 32.667,
    transform: "translate(136.012 244.374)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9491",
    "data-name": "Ret\\xE2ngulo 9491",
    width: 6.691,
    height: 3.201,
    transform: "translate(129.321 277.041)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9493",
    "data-name": "Ret\\xE2ngulo 9493",
    width: 6.691,
    height: 3.201,
    transform: "translate(338.609 277.041)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9494",
    "data-name": "Ret\\xE2ngulo 9494",
    width: 8.658,
    height: 9.525,
    transform: "translate(152.936 339.563)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9495",
    "data-name": "Ret\\xE2ngulo 9495",
    width: 9.427,
    height: 40.406,
    transform: "translate(116.089 201.688)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9496",
    "data-name": "Ret\\xE2ngulo 9496",
    width: 7.79,
    height: 7.965,
    transform: "translate(98.388 340.193)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9497",
    "data-name": "Ret\\xE2ngulo 9497",
    width: 16.416,
    height: 62.359,
    transform: "translate(123.368 126.695)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9498",
    "data-name": "Ret\\xE2ngulo 9498",
    width: 19.102,
    height: 62.746,
    transform: "translate(94.823 126.29)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9499",
    "data-name": "Ret\\xE2ngulo 9499",
    width: 5.925,
    height: 6.896,
    transform: "translate(112.442 113.825)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13804",
    "data-name": "Grupo 13804",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9474",
    "data-name": "Ret\\xE2ngulo 9474",
    width: 500,
    height: 0.25,
    transform: "translate(0 327.4)",
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9475",
    "data-name": "Ret\\xE2ngulo 9475",
    width: 33.12,
    height: 0.25,
    transform: "translate(78.54 335.79)",
    fill: "#ebebeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9476",
    "data-name": "Ret\\xE2ngulo 9476",
    width: 30.171,
    height: 0.249,
    transform: "translate(133.33 343.001)",
    fill: "#ebebeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9477",
    "data-name": "Ret\\xE2ngulo 9477",
    width: 38.25,
    height: 0.249,
    transform: "translate(56.85 345.071)",
    fill: "#ebebeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9478",
    "data-name": "Ret\\xE2ngulo 9478",
    width: 15.9,
    height: 0.249,
    transform: "translate(434 344.531)",
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9479",
    "data-name": "Ret\\xE2ngulo 9479",
    width: 39.32,
    height: 0.249,
    transform: "translate(391.47 344.531)",
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9480",
    "data-name": "Ret\\xE2ngulo 9480",
    width: 30.33,
    height: 0.25,
    transform: "translate(250 335.66)",
    fill: "#ebebeb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9481",
    "data-name": "Ret\\xE2ngulo 9481",
    width: 72.1,
    height: 0.25,
    transform: "translate(284.67 335.66)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13803",
    "data-name": "Grupo 13803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13806",
    "data-name": "Grupo 13806"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7917",
    "data-name": "Caminho 7917",
    d: "M237,282.8H43.91a5.71,5.71,0,0,1-5.7-5.71V5.66A5.71,5.71,0,0,1,43.91,0H237a5.709,5.709,0,0,1,5.71,5.71V277.09A5.709,5.709,0,0,1,237,282.8M43.91.2a5.459,5.459,0,0,0-5.45,5.46V277.09a5.46,5.46,0,0,0,5.45,5.46H237a5.471,5.471,0,0,0,5.46-5.46V5.66A5.47,5.47,0,0,0,237,.2Z",
    fill: "#ebebeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7918",
    "data-name": "Caminho 7918",
    d: "M453.31,282.8H260.21a5.721,5.721,0,0,1-5.71-5.71V5.66A5.72,5.72,0,0,1,260.21,0h193.1A5.71,5.71,0,0,1,459,5.66V277.09a5.71,5.71,0,0,1-5.69,5.71M260.21.2a5.47,5.47,0,0,0-5.46,5.46V277.09a5.471,5.471,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V5.66A5.47,5.47,0,0,0,453.31.2Z",
    fill: "#ebebeb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7919",
    "data-name": "Caminho 7919",
    d: "M381.578,23.393a10.577,10.577,0,0,0-2.391.285,6.515,6.515,0,0,0-6.326-3.756,11.981,11.981,0,0,0-6.519,2.121c-1.3-4.351-5.176-7.259-10.592-7.259-7.714,0-15.775,5.894-18.691,13.423a9.372,9.372,0,0,0-2.176-.247h-.725c-6.642.447-6.171,10.476.517,10.476h47.4a5.221,5.221,0,0,0,4.22-2.122,12.165,12.165,0,0,0,1.844-3.672c1.466-5.106-1.435-9.249-6.565-9.249",
    fill: "#f0f0f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7920",
    "data-name": "Caminho 7920",
    d: "M157.833,72.64c-1.84-12.21-11.57-20.72-25.8-20.72-11.67,0-23.68,5.71-32.62,14.49a13.669,13.669,0,0,0-9.42-3.36c-9.86,0-20.23,8-23.14,17.87a17.864,17.864,0,0,0-.73,4.48l-.2.13c-8.19,5.57-4.13,18.41,5.77,18.41h83.26a15.741,15.741,0,0,0,15.14-11.06v-.12c3.18-10.49-2.29-19.14-12.26-20.12",
    fill: "#f5f5f5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7921",
    "data-name": "Caminho 7921",
    d: "M250,349.92c107.082,0,193.89,5.068,193.89,11.32S357.082,372.56,250,372.56,56.11,367.492,56.11,361.24,142.918,349.92,250,349.92",
    fill: "#f5f5f5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7922",
    "data-name": "Caminho 7922",
    d: "M440.437,131.8a.43.43,0,0,1-.39-.46l2.22-26.7a.43.43,0,0,1,.46-.39.42.42,0,0,1,.38.44l-2.22,26.7a.43.43,0,0,1-.43.39Z",
    fill: "#7e7efc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7923",
    "data-name": "Caminho 7923",
    d: "M439.107,147.642a.43.43,0,0,1-.39-.46l.67-8.08v-.013a.42.42,0,0,1,.459-.377h.013a.42.42,0,0,1,.377.459l-.67,8.08a.43.43,0,0,1-.43.39Z",
    fill: "#7e7efc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7924",
    "data-name": "Caminho 7924",
    d: "M213.161,223.577a8.71,8.71,0,0,1-7.774-9.555l11.63-139.77a10.64,10.64,0,0,1,10.38-9.58h206.47a8.7,8.7,0,0,1,8.78,9.58l-11.63,139.79a10.63,10.63,0,0,1-10.37,9.58H214.167a8.888,8.888,0,0,1-1.006-.045",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7925",
    "data-name": "Caminho 7925",
    d: "M214.167,224.022a8.989,8.989,0,0,1-1.037-.045A9.09,9.09,0,0,1,205,214.022l11.62-139.77a11,11,0,0,1,10.78-10h206.47a9.1,9.1,0,0,1,6.81,3,9.2,9.2,0,0,1,2.37,7.05l-11.63,139.78a11,11,0,0,1-10.77,9.94Zm13.25-158.93a10.21,10.21,0,0,0-10,9.21l-11.63,139.78a8.165,8.165,0,0,0-.042.964,8.3,8.3,0,0,0,8.422,8.176h206.46a10.22,10.22,0,0,0,10-9.21l11.63-139.76a8.3,8.3,0,0,0-8.39-9.16Z",
    fill: "#7e7efc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7926",
    "data-name": "Caminho 7926",
    d: "M217.017,74.252h225.63a8.98,8.98,0,0,0,.042-.984,8.7,8.7,0,0,0-8.822-8.576H227.4a10.64,10.64,0,0,0-10.38,9.56",
    fill: "#7e7efc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7927",
    "data-name": "Caminho 7927",
    d: "M431.277,67.412a1.642,1.642,0,0,1,.21.01,1.879,1.879,0,0,1,1.68,2.06,2.3,2.3,0,0,1-2.24,2.07,1.983,1.983,0,0,1-.231-.01,1.87,1.87,0,0,1-1.659-2.06,2.281,2.281,0,0,1,2.24-2.07",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7928",
    "data-name": "Caminho 7928",
    d: "M422.837,67.412a1.641,1.641,0,0,1,.21.01,1.879,1.879,0,0,1,1.68,2.06,2.3,2.3,0,0,1-2.2,2.07,1.983,1.983,0,0,1-.231-.01,1.87,1.87,0,0,1-1.659-2.06,2.28,2.28,0,0,1,2.2-2.07",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7929",
    "data-name": "Caminho 7929",
    d: "M414.477,67.412a1.642,1.642,0,0,1,.21.01,1.879,1.879,0,0,1,1.68,2.06,2.3,2.3,0,0,1-2.24,2.07,1.983,1.983,0,0,1-.231-.01,1.87,1.87,0,0,1-1.659-2.06,2.281,2.281,0,0,1,2.24-2.07",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7930",
    "data-name": "Caminho 7930",
    d: "M231.357,205.273a6.921,6.921,0,0,1-6.25-7.531l8.11-97.49a8.45,8.45,0,0,1,8.25-7.61h173.67a7,7,0,0,1,.806.034,6.918,6.918,0,0,1,6.194,7.576l-8.16,97.44a8.449,8.449,0,0,1-8.25,7.61H232.087a6.853,6.853,0,0,1-.73-.029",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13762",
    "data-name": "Grupo 13762",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13761",
    "data-name": "Grupo 13761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13760",
    "data-name": "Grupo 13760",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7931",
    "data-name": "Caminho 7931",
    d: "M355.42,110.6a13.224,13.224,0,0,0-18.311,3.8L294.163,180.13A13.224,13.224,0,0,0,305.2,200.591l74.82.218a13.225,13.225,0,0,0,11.95-18.9l-31.893-66a13.232,13.232,0,0,0-4.656-5.308",
    fill: "#263238"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7932",
    "data-name": "Caminho 7932",
    d: "M327.027,100.776a13.238,13.238,0,0,0-18.27,4.088l-42.3,66.245A13.223,13.223,0,0,0,277.541,191.4l74.258.213a13.224,13.224,0,0,0,11.978-18.926l-31.893-66.428a13.239,13.239,0,0,0-4.857-5.478",
    fill: "#7e7efc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7933",
    "data-name": "Caminho 7933",
    d: "M276.4,185.685a6.8,6.8,0,0,1-6.172-3.857,7.921,7.921,0,0,1,.611-7.71L313.32,107.77a8.081,8.081,0,0,1,6.772-3.836,6.8,6.8,0,0,1,6.174,3.871l31.97,66.607a7.9,7.9,0,0,1-.6,7.707,8.067,8.067,0,0,1-6.774,3.823Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7934",
    "data-name": "Caminho 7934",
    d: "M321.382,125.99a5.115,5.115,0,0,1,4.457,5.7l-.508,6.443a5.291,5.291,0,0,1-.1.7l-3.891,19.7a6.123,6.123,0,0,1-5.86,4.978,5.075,5.075,0,0,1-5.115-4.989l-.794-19.784a6.454,6.454,0,0,1,.016-.709l.457-6.42a6.15,6.15,0,0,1,5.948-5.673l4.729.02a5.236,5.236,0,0,1,.662.038m-5.784,42.9a4.646,4.646,0,0,1,.487.029,4.585,4.585,0,0,1,4.04,5.073,5.443,5.443,0,0,1-5.333,5.056l-1.289,0a4.578,4.578,0,0,1-4.524-5.088,5.443,5.443,0,0,1,5.33-5.07Z",
    fill: "#7e7efc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7935",
    "data-name": "Caminho 7935",
    d: "M136.012,329.739h-6.69V235.291a3.3,3.3,0,0,1,3.3-3.3,3.342,3.342,0,0,1,3.35,3.3Z",
    fill: "#7e7efc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13765",
    "data-name": "Grupo 13765",
    opacity: 0.7,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13764",
    "data-name": "Grupo 13764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13763",
    "data-name": "Grupo 13763",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7936",
    "data-name": "Caminho 7936",
    d: "M136.012,329.739h-6.69V235.291a3.3,3.3,0,0,1,3.3-3.3,3.342,3.342,0,0,1,3.35,3.3Z",
    fill: "#fff"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7937",
    "data-name": "Caminho 7937",
    d: "M341.959,231.95h0a3.341,3.341,0,0,1,3.341,3.341v94.448h-6.69V235.291a3.341,3.341,0,0,1,3.341-3.341h.008",
    fill: "#7e7efc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13768",
    "data-name": "Grupo 13768",
    opacity: 0.7,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13767",
    "data-name": "Grupo 13767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13766",
    "data-name": "Grupo 13766",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7938",
    "data-name": "Caminho 7938",
    d: "M341.959,231.95h0a3.341,3.341,0,0,1,3.341,3.341v94.448h-6.69V235.291a3.341,3.341,0,0,1,3.341-3.341h.008",
    fill: "#fff"
  }))))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9485",
    "data-name": "Ret\\xE2ngulo 9485",
    width: 229.359,
    height: 32.668,
    transform: "translate(122.631 244.374)",
    fill: "#7e7efc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13771",
    "data-name": "Grupo 13771",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13770",
    "data-name": "Grupo 13770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13769",
    "data-name": "Grupo 13769",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9486",
    "data-name": "Ret\\xE2ngulo 9486",
    width: 229.359,
    height: 32.668,
    transform: "translate(122.631 244.374)",
    fill: "#fff"
  }))))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9488",
    "data-name": "Ret\\xE2ngulo 9488",
    width: 1.625,
    height: 32.668,
    transform: "translate(351.99 244.373)",
    fill: "#7e7efc"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13774",
    "data-name": "Grupo 13774",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13773",
    "data-name": "Grupo 13773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13772",
    "data-name": "Grupo 13772",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7939",
    "data-name": "Caminho 7939",
    d: "M159.292,277.041h-23.28l11.7-32.668H171Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7940",
    "data-name": "Caminho 7940",
    d: "M201.2,277.041H177.911l11.706-32.668H212.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7941",
    "data-name": "Caminho 7941",
    d: "M243.1,277.041h-23.28l11.706-32.668H254.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7942",
    "data-name": "Caminho 7942",
    d: "M285,277.041h-23.28l11.7-32.668H296.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7943",
    "data-name": "Caminho 7943",
    d: "M326.912,277.041H303.624l11.706-32.668h23.28Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13777",
    "data-name": "Grupo 13777",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13776",
    "data-name": "Grupo 13776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13775",
    "data-name": "Grupo 13775",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9490",
    "data-name": "Ret\\xE2ngulo 9490",
    width: 6.69,
    height: 3.201,
    transform: "translate(129.321 277.041)",
    fill: "#7e7efc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13780",
    "data-name": "Grupo 13780",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13779",
    "data-name": "Grupo 13779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13778",
    "data-name": "Grupo 13778",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9492",
    "data-name": "Ret\\xE2ngulo 9492",
    width: 6.69,
    height: 3.201,
    transform: "translate(338.609 277.041)",
    fill: "#7e7efc"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7944",
    "data-name": "Caminho 7944",
    d: "M274.47,233.575a43.383,43.383,0,0,0-3.729-5.04l.627-.537a44.406,44.406,0,0,1,3.795,5.14Z",
    fill: "#7e7efc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7945",
    "data-name": "Caminho 7945",
    d: "M266.9,224.575A43.847,43.847,0,0,0,253.054,216l.3-.767a44.709,44.709,0,0,1,14.115,8.728Z",
    fill: "#7e7efc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7946",
    "data-name": "Caminho 7946",
    d: "M237.306,215.154A41.907,41.907,0,1,1,195.4,257.061a41.906,41.906,0,0,1,41.907-41.907",
    fill: "#7e7efc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7947",
    "data-name": "Caminho 7947",
    d: "M237.3,217.571a39.49,39.49,0,1,1-39.482,39.5v-.008a39.532,39.532,0,0,1,39.482-39.49m0-.965a40.422,40.422,0,1,0,40.422,40.422A40.422,40.422,0,0,0,237.3,216.606Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7948",
    "data-name": "Caminho 7948",
    d: "M212.773,249.464h49.076a1.6,1.6,0,0,1,1.6,1.6v11.987a1.6,1.6,0,0,1-1.6,1.6H212.773a1.6,1.6,0,0,1-1.6-1.6V251.064a1.6,1.6,0,0,1,1.6-1.6",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7949",
    "data-name": "Caminho 7949",
    d: "M152.936,341.271l6.625-1.717,3.952,15.15-6.625,1.718Z",
    fill: "#1ed6bb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7950",
    "data-name": "Caminho 7950",
    d: "M164.9,352.987c2.34.815,5.608,1.288,11.234.7,1.218-.166,2.261,2.462-.535,3.339s-7.632,2.3-9.639,2.935c-3.268,1.034-4.451,1.542-7.01,2.419a1.245,1.245,0,0,1-1.542-.763l-1.56-5.739,0-.014a.473.473,0,0,1,.346-.573l7.4-2.34a2.04,2.04,0,0,1,1.314.035",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13783",
    "data-name": "Grupo 13783",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13782",
    "data-name": "Grupo 13782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13781",
    "data-name": "Grupo 13781",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7951",
    "data-name": "Caminho 7951",
    d: "M154.969,349.088l6.625-1.717-2.033-7.808-6.625,1.717Z"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7952",
    "data-name": "Caminho 7952",
    d: "M111.462,186.346s14.187,58.4,19.786,77.813c2.673,19.865,20.295,82.6,20.295,82.6l11.26-4.092s-7.7-59.158-11.208-79.82c-3.224-18.866-15.352-76.5-15.352-76.5Z",
    fill: "#7e7efc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13786",
    "data-name": "Grupo 13786",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13785",
    "data-name": "Grupo 13785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13784",
    "data-name": "Grupo 13784",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7953",
    "data-name": "Caminho 7953",
    d: "M116.089,205.212c2.681,10.866,6.143,24.737,9.262,36.882.684-10.287-.745-27.488-4.679-36.935-2.524-6.072-3.715-2.935-4.583.053"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7954",
    "data-name": "Caminho 7954",
    d: "M149.019,343.532l14.371-4.04.456,5.109-12.076,3.488Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7955",
    "data-name": "Caminho 7955",
    d: "M167.413,352.611a.881.881,0,0,0-.079-.877.617.617,0,0,0-.509-.306c-.9-.053-2.348,1.761-2.514,1.971a.149.149,0,0,0,0,.167.148.148,0,0,0,.157.079,9.044,9.044,0,0,0,1.832-.324,1.863,1.863,0,0,0,1.113-.71m-2.6.692c.6-.71,1.533-1.6,2.007-1.577a.307.307,0,0,1,.245.157.546.546,0,0,1,.07.561c-.21.421-1.06.728-2.322.877Z",
    fill: "#7e7efc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7956",
    "data-name": "Caminho 7956",
    d: "M164.573,353.592c.526-.579,1.061-2.209.666-2.857a.631.631,0,0,0-.71-.272.877.877,0,0,0-.578.412c-.456.824.351,2.6.351,2.682a.165.165,0,0,0,.122.087h.079a.136.136,0,0,0,.07-.052m.009-2.822c.228-.044.359.044.359.123a3,3,0,0,1-.464,2.278,3.3,3.3,0,0,1-.254-2.147.463.463,0,0,1,.28-.236Z",
    fill: "#7e7efc"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7957",
    "data-name": "Caminho 7957",
    d: "M126.815,136.959a4.8,4.8,0,0,1,8.763-3.9l.052.113c1.078,2.288,2.287,4.732,3.5,7.107s2.507,4.749,3.847,7.01,2.734,4.513,4.206,6.642a58.568,58.568,0,0,0,4.706,5.942l-.876-.675a1.708,1.708,0,0,0-.877-.272h.149a8.915,8.915,0,0,0,1.034,0,24.584,24.584,0,0,0,2.726-.394c1.91-.368,3.9-.806,5.888-1.306,4-.972,8.053-2.068,12.119-3.049a2.12,2.12,0,0,1,1.595,3.873c-1.858,1.122-3.733,2.112-5.643,3.1s-3.856,1.9-5.828,2.743-3.978,1.673-6.133,2.357c-1.087.342-2.191.666-3.435.929a14.764,14.764,0,0,1-2.1.289,9.88,9.88,0,0,1-1.419,0,6.121,6.121,0,0,1-2.357-.71,3.708,3.708,0,0,1-.736-.517l-.158-.158A68.616,68.616,0,0,1,134.8,152.268c-1.542-2.437-2.944-4.934-4.276-7.466-.658-1.271-1.306-2.542-1.911-3.838s-1.165-2.559-1.752-3.979Z",
    fill: "#1ed6bb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7958",
    "data-name": "Caminho 7958",
    d: "M129.636,153.459a32.6,32.6,0,0,0,11.786-11.83c-3.7-7.632-7.571-13.757-13.214-13.915-13.4-.377,1.428,25.745,1.428,25.745",
    fill: "#e0e0e0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7959",
    "data-name": "Caminho 7959",
    d: "M170.812,157.367l-1.8-1.288c1.665-3.689,6.046-4.382,6.046-4.382l3.961,5.092-5.082,1.3a3.849,3.849,0,0,1-3.12-.719",
    fill: "#1ed6bb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7960",
    "data-name": "Caminho 7960",
    d: "M180.635,154.257l-1.621,2.524-3.961-5.091,1.3-1.043a2.269,2.269,0,0,1,2.918.061l.981.876a2.058,2.058,0,0,1,.386,2.673",
    fill: "#1ed6bb"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7961",
    "data-name": "Caminho 7961",
    d: "M99.247,340.193h6.931l-1.656,15.44H97.591Z",
    fill: "#1ed6bb"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7962",
    "data-name": "Caminho 7962",
    d: "M106.318,355.274c1.963,1.472,5.661,3.023,11.19,4.154,1.236.245,1.341,3.014-1.6,3.014s-8.719-.21-10.822-.21c-3.426,0-4.723.149-7.431.2a1.219,1.219,0,0,1-1.218-1.192l.377-5.923a.492.492,0,0,1,.517-.456h7.79a1.964,1.964,0,0,1,1.192.412",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13789",
    "data-name": "Grupo 13789",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13788",
    "data-name": "Grupo 13788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13787",
    "data-name": "Grupo 13787",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7963",
    "data-name": "Caminho 7963",
    d: "M98.388,348.159h6.931l.859-7.965H99.247Z"
  }))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7964",
    "data-name": "Caminho 7964",
    d: "M99.186,186.328s.578,54.189,1.455,76.657c-2.1,20.513-4.89,83.246-4.89,83.246h12.706s10.384-61.944,11.611-82.852c1.1-19.094,2.628-77.033,2.628-77.033Z",
    fill: "#7e7efc"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7965",
    "data-name": "Caminho 7965",
    d: "M94.857,341.858l15.475-.263-.683,4.636H95.243Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7966",
    "data-name": "Caminho 7966",
    d: "M108.886,355.7a.823.823,0,0,0,.2-.876.6.6,0,0,0-.377-.438c-.85-.324-2.813.972-3.032,1.113a.158.158,0,0,0,.053.28,8.861,8.861,0,0,0,1.849.237,1.933,1.933,0,0,0,1.305-.316m-.289-1.025a.289.289,0,0,1,.175.219.552.552,0,0,1-.114.552c-.324.307-1.235.351-2.48.114.807-.5,1.963-1.06,2.419-.885",
    fill: "#7e7efc"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7967",
    "data-name": "Caminho 7967",
    d: "M105.854,355.8c.693-.395,1.727-1.788,1.569-2.515a.615.615,0,0,0-.587-.465.8.8,0,0,0-.684.211c-.7.631-.543,2.55-.543,2.628a.183.183,0,0,0,.088.132h.078Zm.973-2.708c.237.026.315.131.315.228.106.473-.587,1.533-1.191,2.024a3.34,3.34,0,0,1,.455-2.121.477.477,0,0,1,.351-.14Z",
    fill: "#7e7efc"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7968",
    "data-name": "Caminho 7968",
    d: "M136.243,186.328H99.159c-.263-3.181.473-13.538-.07-26.735a202.259,202.259,0,0,0-3.426-27.051c-.013-.073-.023-.146-.032-.22a4.259,4.259,0,0,1,3.738-4.722h.079c2.235-.315,5.039-.64,7.79-.762a143.09,143.09,0,0,1,15.773,0,42.515,42.515,0,0,1,5.2.876,6.651,6.651,0,0,1,5.117,4.46c2.261,7.335,5.17,21.968,2.918,54.154",
    fill: "#e0e0e0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7969",
    "data-name": "Caminho 7969",
    d: "M111.918,119.2c-4.013,2.752-8-1.63-6.5-4.11a4.608,4.608,0,0,1-.692-7.886c5.538-2.34,11.207,9.244,7.194,12",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7970",
    "data-name": "Caminho 7970",
    d: "M122.424,94.95c3.365.175,3.7,4.25,1.832,4.977a3.182,3.182,0,0,1-2.935,4.609c-4-1.025-2.261-9.761,1.1-9.586",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7971",
    "data-name": "Caminho 7971",
    d: "M118.148,131.552c-4.907.263-7.886-1.4-9.341-2.69a1.989,1.989,0,0,1-.4-2.559c2.226-3.864,1.051-11.5,0-15.878l4.223,3.365,5.74,4.583a18.984,18.984,0,0,0-.368,2.234c-.272,2.673.342,5.127,3.724,6.371a1.961,1.961,0,0,1,.692,3.3,6.97,6.97,0,0,1-4.267,1.271",
    fill: "#1ed6bb"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7972",
    "data-name": "Caminho 7972",
    d: "M139.126,187.9a1.254,1.254,0,0,1-1.271,1.157h-7.432a1.235,1.235,0,0,1-1.19-1.279c1.3-27.015-2.892-48.826-5.827-59.727a1.067,1.067,0,0,1,1.183-1.34,47.546,47.546,0,0,1,5.021.525,7.723,7.723,0,0,1,5.617,5.1c2.2,6.108,6.116,22.556,3.9,55.565",
    fill: "#7e7efc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7973",
    "data-name": "Caminho 7973",
    d: "M94.874,134.181a188.366,188.366,0,0,1,3.365,26.656c.508,12.566-.088,22.687,0,27.007a1.244,1.244,0,0,0,1.27,1.192h13.145a1.244,1.244,0,0,0,1.27-1.218c-.105-21.46-2.532-48.134-5.257-60.139a1.832,1.832,0,0,0-1.911-1.384,69.322,69.322,0,0,0-7.106.648c-2.6.368-5.232,4.776-4.776,7.238",
    fill: "#7e7efc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13792",
    "data-name": "Grupo 13792",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13791",
    "data-name": "Grupo 13791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13790",
    "data-name": "Grupo 13790",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7974",
    "data-name": "Caminho 7974",
    d: "M139.126,187.9a1.254,1.254,0,0,1-1.271,1.157h-7.432a1.235,1.235,0,0,1-1.19-1.279c1.3-27.015-2.892-48.826-5.827-59.727a1.067,1.067,0,0,1,1.183-1.34,47.546,47.546,0,0,1,5.021.525,7.723,7.723,0,0,1,5.617,5.1c2.2,6.108,6.116,22.556,3.9,55.565"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13795",
    "data-name": "Grupo 13795",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13794",
    "data-name": "Grupo 13794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13793",
    "data-name": "Grupo 13793",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7975",
    "data-name": "Caminho 7975",
    d: "M94.874,134.181a188.366,188.366,0,0,1,3.365,26.656c.508,12.566-.088,22.687,0,27.007a1.244,1.244,0,0,0,1.27,1.192h13.145a1.244,1.244,0,0,0,1.27-1.218c-.105-21.46-2.532-48.134-5.257-60.139a1.832,1.832,0,0,0-1.911-1.384,69.322,69.322,0,0,0-7.106.648c-2.6.368-5.232,4.776-4.776,7.238"
  }))))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7976",
    "data-name": "Caminho 7976",
    d: "M95.032,130.755h0a4.788,4.788,0,1,1,8.044,5.2V136c-2.532,4.04-5.091,8.211-7.492,12.347-1.2,2.059-2.348,4.153-3.417,6.212-.526,1.026-1.026,2.06-1.464,3.059a22.479,22.479,0,0,0-1.016,2.734c-.456.061.192,2.287,1.078,4.32s1.989,4.136,3.145,6.2c2.331,4.153,4.908,8.342,7.457,12.452v.052a2.383,2.383,0,0,1-3.715,2.936,106.713,106.713,0,0,1-9.919-11.445,59.931,59.931,0,0,1-4.3-6.554A25.893,25.893,0,0,1,81.6,164.4a13.962,13.962,0,0,1-.675-2.567,10.406,10.406,0,0,1,.14-3.242,26.012,26.012,0,0,1,1.227-4.294c.482-1.288,1-2.506,1.525-3.7,1.06-2.384,2.234-4.653,3.426-6.888C89.66,139.246,92.219,135,95.032,130.755Z",
    fill: "#1ed6bb"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7977",
    "data-name": "Caminho 7977",
    d: "M100.334,150.208s-7.992-3.356-12.18-11.111c3.7-7.6,6.686-12.373,12.329-12.268,11.094.193-.149,23.379-.149,23.379",
    fill: "#e0e0e0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7978",
    "data-name": "Caminho 7978",
    d: "M98.222,183.437l-1,.447c-1.542,2.322,3.382,4.881,3.382,4.881l6.02-4.574-3.251-1.034a7.3,7.3,0,0,0-5.152.28",
    fill: "#1ed6bb"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7979",
    "data-name": "Caminho 7979",
    d: "M108.509,186.758l-1.875-2.568-6.02,4.575,2.427,3.014c.021.026.044.051.067.075a1.192,1.192,0,0,0,1.686.021l3.654-3.671a1.07,1.07,0,0,0,.061-1.446",
    fill: "#1ed6bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13798",
    "data-name": "Grupo 13798",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13797",
    "data-name": "Grupo 13797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13796",
    "data-name": "Grupo 13796",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7980",
    "data-name": "Caminho 7980",
    d: "M112.628,113.825a13.444,13.444,0,0,0-.175,2.769c.289,2.112,3.373,4.6,5.547,4.048a18.578,18.578,0,0,1,.368-2.234Z"
  }))))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7981",
    "data-name": "Caminho 7981",
    d: "M116.177,93.574c7.08,1.7,9.586,11.261,9.078,17.324a9.122,9.122,0,0,1-14.467,6.511c-3.978-2.883-4.5-6.738-5.985-13.206s4.294-12.329,11.374-10.629",
    fill: "#1ed6bb"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7982",
    "data-name": "Caminho 7982",
    d: "M100.824,108.62a3.758,3.758,0,0,1-1.288-4.451s-1.481-.123-1.63-2.288.92-3.408,3.26-4.285c-2.261-4.188,2.506-5.529,2.506-4.53,0,0,.955-3.312,3-4.478s4.013-.07,3.452,1.288c0,0,5.363-5.143,8.921-4.144s3.584,3.75,2.243,5.625c.473-.341,3.523-.254,2.892,2.331s-6.537,3.759-9.245,3.058c1.288,2.165-4.04,2.384-5.258,1.876.316,1.235-1.481,1.892-2.138,1.533,4.136,3.19,2.138,9.806.263,9.709-2.427-1.586-4.548.71-6.975-1.244",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7983",
    "data-name": "Caminho 7983",
    d: "M105.109,106.71c1.7-.263,3.435,1.823,4.1,3.339.736,1.682.123,3.294-1.682,2.812a6.3,6.3,0,0,1-3.444-2.5c-1.017-1.507-.675-3.391,1.025-3.654",
    fill: "#1ed6bb"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/inactive.35b30146fb453871965f1d1485f9fe39.svg";